import React from "react";
import type { IInquiryList } from "service/interface/help";

interface Props {
  data: IInquiryList;
  setData: React.Dispatch<React.SetStateAction<IInquiryList>>;
}

export function AnswerTable({ data, setData }: Props) {
  const handleAnswerInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setData((prev) => ({
      ...prev,
      answer: e.target.value,
    }));
  };

  return (
    <div className="mt-[56px]">
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          답변하기
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[252px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            답변
          </div>
          <div className="flex h-full w-[787px] items-center px-[16px] py-[24px] text-M3 text-gray-5">
            <textarea
              value={data.answer}
              onChange={handleAnswerInput}
              placeholder="내용을 입력해 주세요."
              className="h-[204px] w-full resize-none rounded-[4px] border-[1px] border-gray-1 bg-[#fafafa] px-[24px] py-[16px] text-M3 text-gray-5 outline-none placeholder:text-[#c6c6c6] focus:border-gray-5 focus:ring-0"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
